import { IChatMessage, IChatSource } from 'interfaces/components/chatbot/chatbot';

export interface ChatbotData {
  data: {
    QUESTIONS: string[];
    Welcome_Message: string;
  };
}

export interface AutoCompletionsData {
  suggestions: Array<{ QUESTIONS: string }>;
}

export interface UseResizablePopupOptions {
  initialWidthPx?: number;
  initialHeightPx?: number;
  minWidthPx?: number;
  minHeightPx?: number;
  leftOffsetPx?: number;
  bottomOffsetPx?: number;
  maxWidthPct?: number;
  maxHeightPct?: number;
}

export const addMessage = (
  content: string,
  isUser: boolean,
  isLoading = false,
  responseId?: string,
  sources?: IChatSource[]
): IChatMessage => {
  const generateUniqueId = (): string => {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
      return crypto.randomUUID();
    }
    
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 15);
    return `${timestamp}-${randomPart}`;
  };

  const newMessage: IChatMessage = {
    id: generateUniqueId(),
    content,
    isUser,
    timestamp: new Date(),
    isLoading,
    responseId,
    sources
  };
  return newMessage;
};

export const handleClickOutside = (
  event: MouseEvent,
  isOpen: boolean,
  popupRef: React.RefObject<HTMLDivElement | null>,
  onClose: () => void,
  setShowSuggestions?: (show: boolean) => void
): void => {
  const target = event.target as Node;
  const floatingButton = document.querySelector('[data-chatbot-button]');
  const autocompleteDropdown = document.querySelector(
    '[data-autocomplete-dropdown]'
  );

  if (
    isOpen &&
    popupRef.current &&
    !popupRef.current.contains(target) &&
    !floatingButton?.contains(target) &&
    !autocompleteDropdown?.contains(target)
  ) {
    onClose();
    if (setShowSuggestions) {
      setShowSuggestions(false);
    }
  }
};

export class RateLimitError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RateLimitError';
  }
}
